import { Component, EventEmitter, OnInit } from '@angular/core';
import { CommonRequestResponseService } from 'app/services/common-request-response.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'career-alert-modal',
  templateUrl: './career-modal.component.html',
  styleUrls: ['./career-modal.component.scss']
})
export class CareerModalComponent {
  header: string;
  content: string;
  minimize: Function;
  hide: Function;
  footer = false;
  submitLabel = 'Continue';
  cancelLabel = 'No';
  contentData:  any;
  selectedInteresName: string;
  loader = false;
 constructor(private commonRequestResponseService: CommonRequestResponseService,
  private commonDataSharedService : CommonDataSharedService) {

 }
  selectInterest(interestName) {
    this.selectedInteresName = interestName;
  }

  onSubmit() {
    if (this.selectedInteresName) {
      const localUser = JSON.parse(localStorage.getItem('loginUserData'));
      const studentLocalUserId = JSON.parse(localStorage.getItem('studentLocalId'));
      this.loader = true;
      const json = {
        StudentUserId: studentLocalUserId || localUser.userId,
        ChoosedInterest: this.selectedInteresName
      };
      this.commonRequestResponseService
        .postWithHeader('student/AssessmentTieRankChange', json)
        .subscribe(
          (item: any) => {
            this.loader = false;
            this.commonDataSharedService.careerTabSubmit.next();
            this.hide();
          },
          (err) => {
            this.loader = false;
          }
        );
    }
    }

}
